<template>

<ConfettiExplosion :particleCount="300" :force="1" />
  
    <div id="home_card">
          <center>
            <div>
              <p>Thank you for your purchase !<br>You will receive your searches</p>
            </div>
          </center>
    </div>
    

</template>

<script setup>
import ConfettiExplosion from "vue-confetti-explosion";


</script>
<script>
import { mapGetters } from 'vuex';
import axios from "axios";
export default {
  computed: {
    ...mapGetters(['backend']),
  },
  async created(){
    try{
      this.priceId = this.$route.query.price_id;
      const product_information = await axios.get(`${this.backend}/api/product/${this.priceId}`)
      this.product = product_information.data
      let delivery_search  =this.product.delivery_search_quantity;
      let userdata2 = JSON.parse(localStorage.getItem('userdata'))

      if (!userdata2.hasSubscription){
          userdata2.research = delivery_search
          userdata2.hasPayments = true
          userdata2.hasSubscription = true
          localStorage.setItem('userdata', JSON.stringify(userdata2))
      }
    }catch(err){
      console.log(err)
    }

  },
}
</script>

<style scoped>
#home_card {
margin-top: 70%;
height: 48vh;
}

@media only screen and (min-width: 600px) {
  #home_card {
    margin-top: 20%;
  }
}

</style>